// extracted by mini-css-extract-plugin
export default {"body":"body-KvU4J","row":"row-kJ94H","label":"label-YopFn","checkbox":"checkbox-ut4Gf"};